export default __webpack_public_path__ + "static/media/YELLOW_MAP.2b744eef.png";